module.exports = __webpack_public_path__ + "static/media/happy6.5871c552.svg";